var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCenterBeam(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 25,
    viewBox: "0 0 89 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#llzo7zzdda)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 16 18 1M18 16 31 1M31 16 44 1M58 16 45 1M71 16 58 1M84 16 71 1",
    stroke: "#9E9E9E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M84.07 18.101c.8.204 1.612.403 2.366.746.756.336 1.434.84 1.91 1.476l-.157.098a4.43 4.43 0 0 0-.814-.82 5.247 5.247 0 0 0-1.02-.607c-.733-.332-1.53-.545-2.332-.732l.048-.16z",
    fill: "#4D4D4D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m88.707 20.676-.077-.101-.099.062.078.1.098-.061zM88.525 20.791l-.078-.1-.098.062.077.1.099-.062z",
    fill: "#CCC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m88.458 20.25.246.321-.386.244-.246-.32a.11.11 0 0 1 .031-.163l.177-.112a.137.137 0 0 1 .18.03h-.002zM4.636 18.101c-.8.204-1.612.403-2.366.746-.755.336-1.434.84-1.91 1.476l.157.098c.233-.304.503-.581.814-.82.31-.238.656-.44 1.02-.607.734-.332 1.531-.545 2.332-.732l-.047-.16z",
    fill: "#4D4D4D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m.1 20.74.078-.1-.099-.063-.077.101.098.063zM.281 20.853l.077-.1-.098-.063-.077.101.098.062z",
    fill: "#CCC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m.635 20.494-.246.321-.386-.244.246-.32a.137.137 0 0 1 .179-.03l.177.112c.057.036.073.109.032.162H.635z",
    fill: "#4D4D4D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M59.258 21.17h-29.81L16.04 17.974h56.622L59.258 21.17z",
    fill: "#757575"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M59.258 20.533h-29.81L16.04 17.338h56.622l-13.405 3.195z",
    fill: "#000",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.3
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M37.01 18.127h-.838v2.407h.839v-2.407zM42.185 18.127h-.838v2.407h.838v-2.407zM47.36 18.127h-.838v2.407h.838v-2.407zM52.535 18.127h-.839v2.407h.84v-2.407z",
    fill: "#757575"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M59.258 21.17h-29.81L16.04 17.974h56.622L59.258 21.17z",
    fill: "#000",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.3
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M86.84 18.66h1.747c.229 0 .414-.168.414-.375V17.11c0-.207-.185-.375-.414-.375H86.84c-.229 0-.414.168-.414.375v1.175c0 .207.185.375.414.375z",
    fill: "#333"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M86.443 16.999a.466.466 0 0 1 .121-.017h1.748c.228 0 .413.168.413.375v1.175a.343.343 0 0 1-.016.108c.168-.048.29-.189.29-.359v-1.174c0-.207-.185-.376-.413-.376h-1.75a.412.412 0 0 0-.397.266l.004.002z",
    fill: "#fff"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "m84.788 17.983 3.465.185c.176.009.325-.118.325-.277v-.467c0-.16-.15-.288-.325-.277l-3.465.185v.653-.002z",
    fill: "#4D4D4D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m87.51 17.585.686-.005v-.28l-.685.025v.26zM86.693 17.592l.561-.005v-.252l-.56.02v.237zM86.01 17.597l.47-.003v-.23l-.47.017v.216zM85.436 17.6h.395v-.212l-.395.014v.199zM87.51 17.985l.686.026v-.28l-.685-.005v.259zM86.693 17.954l.561.02v-.25l-.56-.005v.235zM86.01 17.93l.47.017v-.23l-.47-.003v.216zM85.436 17.908l.395.015v-.21l-.395-.004v.199zM88.453 18.844h-.221c-.108 0-.193-.08-.193-.175v-.127h.606v.127c0 .098-.086.175-.192.175zM87.466 18.844h-.221c-.108 0-.193-.08-.193-.175v-.127h.606v.127c0 .098-.087.175-.192.175zM.906 18.462l-.744-.312a.204.204 0 0 1-.13-.185v-.534c0-.08.05-.152.13-.185l.744-.312v1.528z",
    fill: "#333"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M.904 16.934v.1l-.623.26a.23.23 0 0 0-.148.21v.6c0 .011.002.023.004.035a.202.202 0 0 1-.108-.173v-.533c0-.08.051-.15.13-.185l.745-.31v-.004z",
    fill: "#fff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M2.26 17.027v1.344c0 .16-.143.29-.32.29h-.906a.337.337 0 0 1-.217-.078.275.275 0 0 1-.106-.214v-1.344c0-.161.144-.292.321-.292h.905c.151 0 .278.096.31.225.006.02.01.045.01.069h.003z",
    fill: "#333"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M2.25 16.958H1.116c-.164 0-.296.202-.296.45v1.175a.275.275 0 0 1-.106-.214v-1.344c0-.161.143-.292.321-.292h.905c.151 0 .278.096.31.225h.002z",
    fill: "#fff"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m4.866 17.983-3.465.185c-.176.009-.325-.118-.325-.277v-.467c0-.16.15-.288.325-.277l3.465.185v.653-.002z",
    fill: "#4D4D4D"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m2.142 17.585-.684-.005v-.28l.684.025v.26zM2.962 17.592l-.562-.005v-.252l.562.02v.237zM3.642 17.597l-.466-.003v-.23l.466.017v.216zM4.218 17.6h-.395v-.212l.395.014v.199zM2.142 17.985l-.684.026v-.28l.684-.005v.259zM2.962 17.954l-.562.02v-.25l.562-.005v.235zM3.642 17.93l-.466.017v-.23l.466-.003v.216zM4.218 17.908l-.395.015v-.21l.395-.004v.199z",
    fill: "#333"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M17.698 18.495H10.92v.904h6.777v-.904z",
    fill: "#1A1A1A"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M19.303 19.112H9.311c-.506 0-.916.373-.916.832v1.003c0 .46.41.831.916.831h9.992c.506 0 .916-.372.916-.831v-1.003c0-.46-.41-.832-.916-.832z",
    fill: "#333"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M77.788 18.495H71.01v.904h6.777v-.904z",
    fill: "#1A1A1A"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M79.395 19.112h-9.992c-.506 0-.917.373-.917.832v1.003c0 .46.41.831.917.831h9.992c.506 0 .916-.372.916-.831v-1.003c0-.46-.41-.832-.916-.832z",
    fill: "#333"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M70.99 21.704c.242-1.512-.77-2.936-2.26-3.181-1.49-.245-2.893.78-3.135 2.292-.242 1.511.77 2.936 2.26 3.181 1.49.245 2.893-.781 3.135-2.292z",
    fill: "gray"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M68.292 23.812c1.39 0 2.518-1.144 2.518-2.555 0-1.41-1.127-2.554-2.518-2.554-1.391 0-2.519 1.143-2.519 2.554 0 1.411 1.128 2.555 2.519 2.555z",
    fill: "#4D4D4D"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M68.291 23.037c.97 0 1.755-.797 1.755-1.78s-.786-1.78-1.755-1.78c-.968 0-1.754.797-1.754 1.78s.785 1.78 1.754 1.78z",
    fill: "#333"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M68.84 21.257a.553.553 0 0 1-.55.558.552.552 0 0 1-.549-.558c0-.308.245-.557.55-.557.304 0 .549.249.549.557z",
    fill: "#4D4D4D"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M79.603 23.82c1.394-.586 2.056-2.208 1.479-3.622-.578-1.415-2.176-2.087-3.57-1.5-1.395.585-2.057 2.207-1.48 3.622.578 1.414 2.176 2.086 3.57 1.5z",
    fill: "gray"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M78.555 23.812c1.391 0 2.519-1.144 2.519-2.555 0-1.41-1.128-2.554-2.519-2.554-1.39 0-2.518 1.143-2.518 2.554 0 1.411 1.128 2.555 2.518 2.555z",
    fill: "#4D4D4D"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M78.556 23.037c.969 0 1.754-.797 1.754-1.78s-.785-1.78-1.754-1.78-1.754.797-1.754 1.78.785 1.78 1.754 1.78z",
    fill: "#333"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M79.106 21.257a.553.553 0 0 1-.549.558.552.552 0 0 1-.55-.558c0-.308.246-.557.55-.557.304 0 .55.249.55.557zM73.338 20.707h-1.666v.257h1.666v-.257zM73.338 21.17h-1.666v.257h1.666v-.257zM73.338 20.246h-1.666v.257h1.666v-.257z",
    fill: "#4D4D4D"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "m73.34 20.503-1.668.477v-.257l1.668-.477v.257z",
    fill: "gray"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M73.338 21.631h-1.666v.258h1.666v-.258zM73.338 22.102h-1.666v.258h1.666v-.258z",
    fill: "#4D4D4D"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "m73.34 20.966-1.668.475v-.257l1.668-.477v.259zM73.34 21.427l-1.668.477v-.257l1.668-.477v.257zM73.34 21.89l-1.668.475v-.257l1.668-.477v.26z",
    fill: "gray"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M73.338 19.785h-1.666v.257h1.666v-.257z",
    fill: "#4D4D4D"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "m73.34 20.042-1.668.475v-.257l1.668-.475v.257z",
    fill: "gray"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M75.173 20.707h-1.666v.257h1.666v-.257zM75.173 21.17h-1.666v.257h1.666v-.257zM75.173 20.246h-1.666v.257h1.666v-.257z",
    fill: "#4D4D4D"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "m75.173 20.503-1.666.477v-.257l1.666-.477v.257z",
    fill: "gray"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M75.173 21.631h-1.666v.258h1.666v-.258zM75.173 22.102h-1.666v.258h1.666v-.258z",
    fill: "#4D4D4D"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "m75.173 20.966-1.666.475v-.257l1.666-.477v.259zM75.173 21.427l-1.666.477v-.257l1.666-.477v.257zM75.173 21.89l-1.666.475v-.257l1.666-.477v.26z",
    fill: "gray"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M75.173 19.785h-1.666v.257h1.666v-.257z",
    fill: "#4D4D4D"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "m75.173 20.042-1.666.475v-.257l1.666-.475v.257z",
    fill: "gray"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M79.788 19.793a.848.848 0 0 0-.593-.315l-3.695-.285h-4.154l-3.695.285a.842.842 0 0 0-.593.315.866.866 0 0 0-.147.811l.27.83h2.693l1.031 1.178a.806.806 0 0 0 .605.276h3.828a.806.806 0 0 0 .605-.276l1.031-1.178h2.692l.27-.83a.865.865 0 0 0-.146-.81h-.002zm-8.952 1.204a.197.197 0 0 1-.316.16l-.96-.736v-.434c0-.092.074-.168.165-.168h.945c.091 0 .166.076.166.168v1.01zm4.462.919c0 .192-.154.35-.345.35h-3.061a.348.348 0 0 1-.345-.35v-1.747c0-.192.154-.35.345-.35h3.06c.19 0 .346.156.346.35v1.747zm1.987-1.495-.96.736a.197.197 0 0 1-.316-.16v-1.01c0-.092.074-.168.166-.168h.944c.092 0 .166.076.166.168v.434z",
    fill: "gray"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M68.732 20.632h-.88a.179.179 0 0 0-.178.18v.893c0 .1.08.18.177.18h.88c.099 0 .178-.08.178-.18v-.893c0-.1-.08-.18-.177-.18zM78.998 20.632h-.88a.179.179 0 0 0-.178.18v.893c0 .1.08.18.178.18h.88c.098 0 .178-.08.178-.18v-.893c0-.1-.08-.18-.178-.18z",
    fill: "#4D4D4D"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M11.232 21.702c.256-1.511-.814-2.935-2.39-3.18-1.575-.246-3.059.78-3.315 2.292-.255 1.511.814 2.935 2.39 3.18 1.575.246 3.06-.78 3.315-2.292z",
    fill: "gray"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M8.38 23.812c1.471 0 2.663-1.144 2.663-2.555 0-1.41-1.192-2.554-2.662-2.554-1.471 0-2.663 1.143-2.663 2.554 0 1.411 1.192 2.555 2.663 2.555z",
    fill: "#4D4D4D"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M8.38 23.037c1.025 0 1.855-.797 1.855-1.78s-.83-1.78-1.855-1.78c-1.024 0-1.855.797-1.855 1.78s.83 1.78 1.855 1.78z",
    fill: "#333"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M8.961 21.257a.57.57 0 0 1-.58.558.568.568 0 0 1-.581-.558c0-.308.259-.557.58-.557.322 0 .581.249.581.557z",
    fill: "#4D4D4D"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M22.088 21.703c.255-1.511-.814-2.935-2.39-3.18-1.575-.246-3.06.78-3.315 2.292-.256 1.511.814 2.935 2.39 3.18 1.575.246 3.059-.78 3.315-2.292z",
    fill: "gray"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M19.235 23.812c1.47 0 2.663-1.144 2.663-2.555 0-1.41-1.192-2.554-2.663-2.554-1.47 0-2.663 1.143-2.663 2.554 0 1.411 1.192 2.555 2.663 2.555z",
    fill: "#4D4D4D"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M19.236 23.037c1.024 0 1.855-.796 1.855-1.78 0-.982-.83-1.779-1.855-1.779s-1.855.797-1.855 1.78.83 1.78 1.855 1.78z",
    fill: "#333"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M19.816 21.257a.57.57 0 0 1-.58.558.568.568 0 0 1-.582-.558c0-.308.26-.557.581-.557.322 0 .58.249.58.557zM13.717 20.706h-1.762v.258h1.762v-.258zM13.717 21.17h-1.762v.257h1.762v-.258zM13.717 20.246h-1.762v.257h1.762v-.257z",
    fill: "#4D4D4D"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "m13.717 20.503-1.762.476v-.257l1.762-.476v.257z",
    fill: "gray"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M13.717 21.63h-1.762v.258h1.762v-.257zM13.717 22.102h-1.762v.257h1.762v-.257z",
    fill: "#4D4D4D"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "m13.717 20.965-1.762.475v-.257l1.762-.477v.26zM13.717 21.427l-1.762.476v-.257l1.762-.477v.258zM13.717 21.89l-1.762.475v-.257l1.762-.477v.259z",
    fill: "gray"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M13.717 19.784h-1.762v.257h1.762v-.257z",
    fill: "#4D4D4D"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "m13.717 20.041-1.762.475v-.257l1.762-.475v.257z",
    fill: "gray"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M15.658 20.706h-1.762v.258h1.762v-.258zM15.658 21.17h-1.762v.257h1.762v-.258zM15.658 20.246h-1.762v.257h1.762v-.257z",
    fill: "#4D4D4D"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "m15.658 20.503-1.762.476v-.257l1.762-.476v.257z",
    fill: "gray"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M15.658 21.63h-1.762v.258h1.762v-.257zM15.658 22.102h-1.762v.257h1.762v-.257z",
    fill: "#4D4D4D"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "m15.658 20.965-1.762.475v-.257l1.762-.477v.26zM15.658 21.427l-1.762.476v-.257l1.762-.477v.258zM15.658 21.89l-1.762.475v-.257l1.762-.477v.259z",
    fill: "gray"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M15.658 19.784h-1.762v.257h1.762v-.257z",
    fill: "#4D4D4D"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "m15.658 20.041-1.762.475v-.257l1.762-.475v.257z",
    fill: "gray"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M20.537 19.793a.913.913 0 0 0-.627-.316l-3.907-.284h-4.392l-3.907.284a.906.906 0 0 0-.627.316.829.829 0 0 0-.155.81l.285.83h2.847l1.09 1.179a.874.874 0 0 0 .64.276h4.048a.874.874 0 0 0 .64-.276l1.09-1.178h2.847l.286-.83a.828.828 0 0 0-.156-.811h-.002zm-9.466 1.204c0 .164-.196.259-.334.159l-1.015-.735v-.434c0-.093.079-.168.175-.168h.999c.096 0 .175.075.175.168v1.01zm4.718.919c0 .192-.163.35-.365.35h-3.236a.358.358 0 0 1-.365-.35v-1.748c0-.192.163-.35.365-.35h3.236c.2 0 .365.157.365.35v1.748zm2.102-1.495-1.015.735c-.138.1-.335.005-.335-.16v-1.01c0-.092.079-.167.175-.167h1c.096 0 .175.075.175.168v.434z",
    fill: "gray"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M8.844 20.631h-.93a.184.184 0 0 0-.188.18v.894c0 .1.084.18.187.18h.931c.104 0 .188-.08.188-.18v-.894c0-.1-.084-.18-.188-.18zM19.7 20.631h-.93a.184.184 0 0 0-.188.18v.894c0 .1.084.18.188.18h.93c.104 0 .188-.08.188-.18v-.894c0-.1-.084-.18-.187-.18z",
    fill: "#4D4D4D"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M60.154 19.548v1.389c0 .128-.13.233-.29.233h-3.698c-.16 0-.291-.105-.291-.233v-1.389c0-.128.13-.233.291-.233h3.697c.16 0 .291.104.291.233z",
    fill: "#757575"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M60.154 19.548v.314h-4.279v-.314c0-.128.13-.233.291-.233h3.697c.16 0 .291.104.291.233z",
    fill: "#fff",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.154 20.623v.314c0 .128-.13.233-.29.233h-3.698c-.16 0-.291-.105-.291-.233v-.314h4.28z",
    fill: "#000",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.726 19.824v.365h-4.974v-.365c0-.149.151-.27.338-.27h4.298c.187 0 .338.121.338.27z",
    fill: "#fff",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5
  }), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M53.383 19.548v1.389c0 .128-.13.233-.291.233h-3.697c-.161 0-.292-.105-.292-.233v-1.389c0-.128.13-.233.291-.233h3.698c.16 0 .29.104.29.233z",
    fill: "#757575"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M53.383 19.548v.314h-4.28v-.314c0-.128.13-.233.291-.233h3.698c.16 0 .29.104.29.233z",
    fill: "#fff",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.383 20.623v.314c0 .128-.13.233-.291.233h-3.697c-.161 0-.292-.105-.292-.233v-.314h4.28z",
    fill: "#000",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5
  }), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M85.782 16.632H2.922v2.314h82.86v-2.314z",
    fill: "#757575"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M85.208 18.422v-1.27H3.498v1.27h81.71z",
    fill: "#000",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.4
  }), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M8.212 17.49h-.48v.575h.48v-.574z",
    fill: "#757575"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M8.35 17.289h-.757v.324h.757v-.324zM8.35 17.964h-.757v.324h.757v-.324zM16.296 17.49h-.48v.575h.48v-.574z",
    fill: "#757575"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M16.434 17.289h-.757v.324h.757v-.324zM16.434 17.964h-.757v.324h.757v-.324zM24.38 17.49h-.48v.575h.48v-.574z",
    fill: "#757575"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M24.52 17.289h-.757v.324h.757v-.324zM24.52 17.964h-.757v.324h.757v-.324zM32.465 17.49h-.48v.575h.48v-.574z",
    fill: "#757575"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M32.605 17.289h-.757v.324h.757v-.324zM32.605 17.964h-.757v.324h.757v-.324zM40.55 17.49h-.48v.575h.48v-.574z",
    fill: "#757575"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M40.69 17.289h-.758v.324h.757v-.324zM40.69 17.964h-.758v.324h.757v-.324zM48.635 17.49h-.48v.575h.48v-.574z",
    fill: "#757575"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M48.773 17.289h-.757v.324h.757v-.324zM48.773 17.964h-.757v.324h.757v-.324zM56.72 17.49h-.48v.575h.48v-.574z",
    fill: "#757575"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M56.857 17.289H56.1v.324h.757v-.324zM56.857 17.964H56.1v.324h.757v-.324zM64.804 17.49h-.48v.575h.48v-.574z",
    fill: "#757575"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M64.942 17.289h-.757v.324h.757v-.324zM64.942 17.964h-.757v.324h.757v-.324zM72.888 17.49h-.48v.575h.48v-.574z",
    fill: "#757575"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M73.028 17.289h-.758v.324h.758v-.324zM73.028 17.964h-.758v.324h.758v-.324zM80.972 17.49h-.48v.575h.48v-.574zM8.212 17.49h-.48v.575h.48v-.574zM16.296 17.49h-.48v.575h.48v-.574zM24.38 17.49h-.48v.575h.48v-.574zM32.465 17.49h-.48v.575h.48v-.574zM40.55 17.49h-.48v.575h.48v-.574zM48.635 17.49h-.48v.575h.48v-.574zM56.72 17.49h-.48v.575h.48v-.574zM64.804 17.49h-.48v.575h.48v-.574z",
    fill: "#757575"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M72.888 17.49h-.48v.575h.48v-.574zM80.972 17.49h-.48v.575h.48v-.574z",
    fill: "#757575"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M81.112 17.289h-.757v.324h.757v-.324zM81.112 17.964h-.757v.324h.757v-.324zM5.505 18.705v1.745c0 .125-.111.226-.25.226H3.48c-.138 0-.25-.1-.25-.226v-1.745h.242V20.2c0 .125.112.227.25.227h1.29c.138 0 .25-.102.25-.227v-1.496h.243zM85.476 18.705v1.745c0 .125-.112.226-.25.226h-1.775c-.138 0-.25-.1-.25-.226v-1.745h.242V20.2c0 .125.112.227.25.227h1.29c.138 0 .25-.102.25-.227v-1.496h.243zM4.249.03h.674c.183 0 .333.136.333.302v16.163h-1.34V.332c0-.166.15-.302.333-.302z",
    fill: "#757575"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4.249.03h.674c.183 0 .333.136.333.302v16.163h-1.34V.332c0-.166.15-.302.333-.302z",
    fill: "#fff",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.3
  }), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M5.654 16.104v1.377H3.516v-1.377c0-.21.187-.379.415-.379h1.306c.23 0 .417.17.417.379z",
    fill: "#757575"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M5.654 17.049H3.516v.432h2.138v-.432z",
    fill: "#000",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.654 16.104v.16H3.516v-.16c0-.21.187-.379.415-.379h1.306c.23 0 .417.17.417.379z",
    fill: "#fff",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.3
  }), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M17.553.03h.675c.183 0 .332.136.332.302v16.163h-1.34V.332c0-.166.15-.302.333-.302z",
    fill: "#757575"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M17.553.03h.675c.183 0 .332.136.332.302v16.163h-1.34V.332c0-.166.15-.302.333-.302z",
    fill: "#fff",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.3
  }), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M18.959 16.104v1.377H16.82v-1.377c0-.21.187-.379.416-.379h1.305c.23 0 .418.17.418.379z",
    fill: "#757575"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M18.959 17.049H16.82v.432h2.139v-.432z",
    fill: "#000",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.959 16.104v.16H16.82v-.16c0-.21.187-.379.416-.379h1.305c.23 0 .418.17.418.379z",
    fill: "#fff",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.3
  }), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M30.857.03h.674c.184 0 .333.136.333.302v16.163h-1.34V.332c0-.166.15-.302.333-.302z",
    fill: "#757575"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M30.857.03h.674c.184 0 .333.136.333.302v16.163h-1.34V.332c0-.166.15-.302.333-.302z",
    fill: "#fff",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.3
  }), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M32.265 16.104v1.377h-2.139v-1.377c0-.21.187-.379.416-.379h1.305c.23 0 .418.17.418.379z",
    fill: "#757575"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M32.265 17.049h-2.139v.432h2.139v-.432z",
    fill: "#000",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.265 16.104v.16h-2.139v-.16c0-.21.187-.379.416-.379h1.305c.23 0 .418.17.418.379z",
    fill: "#fff",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.3
  }), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M44.164.03h.674c.183 0 .333.136.333.302v16.163h-1.34V.332c0-.166.15-.302.333-.302z",
    fill: "#757575"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M44.164.03h.674c.183 0 .333.136.333.302v16.163h-1.34V.332c0-.166.15-.302.333-.302z",
    fill: "#fff",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.3
  }), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M45.57 16.104v1.377h-2.14v-1.377c0-.21.188-.379.416-.379h1.306c.23 0 .417.17.417.379z",
    fill: "#757575"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M45.57 17.049h-2.14v.432h2.14v-.432z",
    fill: "#000",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.57 16.104v.16h-2.14v-.16c0-.21.188-.379.416-.379h1.306c.23 0 .417.17.417.379z",
    fill: "#fff",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.3
  }), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M57.467.03h.675c.183 0 .332.136.332.302v16.163h-1.34V.332c0-.166.15-.302.333-.302z",
    fill: "#757575"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M57.467.03h.675c.183 0 .332.136.332.302v16.163h-1.34V.332c0-.166.15-.302.333-.302z",
    fill: "#fff",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.3
  }), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M58.875 16.104v1.377h-2.139v-1.377c0-.21.187-.379.416-.379h1.306c.23 0 .417.17.417.379z",
    fill: "#757575"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M58.875 17.049h-2.139v.432h2.139v-.432z",
    fill: "#000",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.875 16.104v.16h-2.139v-.16c0-.21.187-.379.416-.379h1.306c.23 0 .417.17.417.379z",
    fill: "#fff",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.3
  }), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M70.774.03h.674c.184 0 .333.136.333.302v16.163h-1.34V.332c0-.166.15-.302.333-.302z",
    fill: "#757575"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M70.774.03h.674c.184 0 .333.136.333.302v16.163h-1.34V.332c0-.166.15-.302.333-.302z",
    fill: "#fff",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.3
  }), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M72.18 16.104v1.377H70.04v-1.377c0-.21.187-.379.416-.379h1.305c.23 0 .418.17.418.379z",
    fill: "#757575"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M72.18 17.049H70.04v.432h2.139v-.432z",
    fill: "#000",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.18 16.104v.16H70.04v-.16c0-.21.187-.379.416-.379h1.305c.23 0 .418.17.418.379z",
    fill: "#fff",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.3
  }), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M84.078.03h.674c.183 0 .333.136.333.302v16.163h-1.34V.332c0-.166.15-.302.333-.302z",
    fill: "#757575"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M84.078.03h.674c.183 0 .333.136.333.302v16.163h-1.34V.332c0-.166.15-.302.333-.302z",
    fill: "#fff",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.3
  }), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M85.485 16.104v1.377h-2.138v-1.377c0-.21.187-.379.415-.379h1.306c.23 0 .417.17.417.379z",
    fill: "#757575"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M85.483 17.049h-2.138v.432h2.138v-.432z",
    fill: "#000",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.485 16.104v.16h-2.138v-.16c0-.21.187-.379.415-.379h1.306c.23 0 .417.17.417.379z",
    fill: "#fff",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.3
  }), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M6.904 17.742H5.261v1.167h1.642v-1.167z",
    fill: "#000"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M6.276 17.095h-.383v2.462h.383v-2.462z",
    fill: "#757575"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M7.44 18.501v-.348H4.727v.348H7.44z",
    fill: "#757575"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M6.084 19.856c-.93 0-1.688-.686-1.688-1.532 0-.845.756-1.53 1.688-1.53.931 0 1.687.685 1.687 1.53 0 .846-.756 1.532-1.687 1.532zm0-2.713c-.718 0-1.304.532-1.304 1.183 0 .652.584 1.183 1.304 1.183.72 0 1.303-.53 1.303-1.183s-.584-1.183-1.303-1.183z",
    fill: "#757575"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M6.084 18.753c.26 0 .47-.19.47-.427 0-.235-.21-.427-.47-.427s-.47.192-.47.427c0 .236.21.427.47.427z",
    fill: "#757575"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fill: "#9E9E9E",
    d: "M4 .03h81v1H4z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "llzo7zzdda"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 .03)",
    d: "M0 0h89v24H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCenterBeam);
export default __webpack_public_path__ + "static/media/center_beam.0be27de124c4e907ac07236349d189f4.svg";
export { ForwardRef as ReactComponent };